<template>
<ul class="list-unstyled" @click="onClickButton">
	<li data-countryCode="GB" value="+44">UK (+44)</li>
	<li data-countryCode="US" value="+1">USA (+1)</li>
	<li data-countryCode="DZ" value="+213">Algeria (+213)</li>
	<li data-countryCode="AD" value="+376">Andorra (+376)</li>
	<li data-countryCode="AO" value="+244">Angola (+244)</li>
	<li data-countryCode="AI" value="+1264">Anguilla (+1264)</li>
	<li data-countryCode="AG" value="+1268">Antigua & Barbuda (+1268)</li>
	<li data-countryCode="AR" value="+54">Argentina (+54)</li>
	<li data-countryCode="AM" value="+374">Armenia (+374)</li>
	<li data-countryCode="AW" value="+297">Aruba (+297)</li>
	<li data-countryCode="AU" value="+61">Australia (+61)</li>
	<li data-countryCode="AT" value="+43">Austria (+43)</li>
	<li data-countryCode="AZ" value="+994">Azerbaijan (+994)</li>
	<li data-countryCode="BS" value="+1242">Bahamas (+1242)</li>
	<li data-countryCode="BH" value="+973">Bahrain (+973)</li>
	<li data-countryCode="BD" value="+880">Bangladesh (+880)</li>
	<li data-countryCode="BB" value="+1246">Barbados (+1246)</li>
	<li data-countryCode="BY" value="+375">Belarus (+375)</li>
	<li data-countryCode="BE" value="+32">Belgium (+32)</li>
	<li data-countryCode="BZ" value="+501">Belize (+501)</li>
	<li data-countryCode="BJ" value="+229">Benin (+229)</li>
	<li data-countryCode="BM" value="+1441">Bermuda (+1441)</li>
	<li data-countryCode="BT" value="+975">Bhutan (+975)</li>
	<li data-countryCode="BO" value="+591">Bolivia (+591)</li>
	<li data-countryCode="BA" value="+387">Bosnia Herzegovina (+387)</li>
	<li data-countryCode="BW" value="+267">Botswana (+267)</li>
	<li data-countryCode="BR" value="+55">Brazil (+55)</li>
	<li data-countryCode="BN" value="+673">Brunei (+673)</li>
	<li data-countryCode="BG" value="+359">Bulgaria (+359)</li>
	<li data-countryCode="BF" value="+226">Burkina Faso (+226)</li>
	<li data-countryCode="BI" value="+257">Burundi (+257)</li>
	<li data-countryCode="KH" value="+855">Cambodia (+855)</li>
	<li data-countryCode="CM" value="+237">Cameroon (+237)</li>
	<li data-countryCode="CA" value="+1">Canada (+1)</li>
	<li data-countryCode="CV" value="+238">Cape Verde Islands (+238)</li>
	<li data-countryCode="KY" value="+1345">Cayman Islands (+1345)</li>
	<li data-countryCode="CF" value="+236">Central African Republic (+236)</li>
	<li data-countryCode="CL" value="+56">Chile (+56)</li>
	<li data-countryCode="CN" value="+86">China (+86)</li>
	<li data-countryCode="CO" value="+57">Colombia (+57)</li>
	<li data-countryCode="KM" value="+269">Comoros (+269)</li>
	<li data-countryCode="CG" value="+242">Congo (+242)</li>
	<li data-countryCode="CK" value="+682">Cook Islands (+682)</li>
	<li data-countryCode="CR" value="+506">Costa Rica (+506)</li>
	<li data-countryCode="HR" value="+385">Croatia (+385)</li>
	<li data-countryCode="CU" value="+53">Cuba (+53)</li>
	<li data-countryCode="CY" value="+90392">Cyprus North (+90392)</li>
	<li data-countryCode="CY" value="+357">Cyprus South (+357)</li>
	<li data-countryCode="CZ" value="+42">Czech Republic (+42)</li>
	<li data-countryCode="DK" value="+45">Denmark (+45)</li>
	<li data-countryCode="DJ" value="+253">Djibouti (+253)</li>
	<li data-countryCode="DM" value="+1809">Dominica (+1809)</li>
	<li data-countryCode="DO" value="+1809">Dominican Republic (+1809)</li>
	<li data-countryCode="EC" value="+593">Ecuador (+593)</li>
	<li data-countryCode="EG" value="+20">Egypt (+20)</li>
	<li data-countryCode="SV" value="+503">El Salvador (+503)</li>
	<li data-countryCode="GQ" value="+240">Equatorial Guinea (+240)</li>
	<li data-countryCode="ER" value="+291">Eritrea (+291)</li>
	<li data-countryCode="EE" value="+372">Estonia (+372)</li>
	<li data-countryCode="ET" value="+251">Ethiopia (+251)</li>
	<li data-countryCode="FK" value="+500">Falkland Islands (+500)</li>
	<li data-countryCode="FO" value="+298">Faroe Islands (+298)</li>
	<li data-countryCode="FJ" value="+679">Fiji (+679)</li>
	<li data-countryCode="FI" value="+358">Finland (+358)</li>
	<li data-countryCode="FR" value="+33">France (+33)</li>
	<li data-countryCode="GF" value="+594">French Guiana (+594)</li>
	<li data-countryCode="PF" value="+689">French Polynesia (+689)</li>
	<li data-countryCode="GA" value="+241">Gabon (+241)</li>
	<li data-countryCode="GM" value="+220">Gambia (+220)</li>
	<li data-countryCode="GE" value="+7880">Georgia (+7880)</li>
	<li data-countryCode="DE" value="+49">Germany (+49)</li>
	<li data-countryCode="GH" value="+233">Ghana (+233)</li>
	<li data-countryCode="GI" value="+350">Gibraltar (+350)</li>
	<li data-countryCode="GR" value="+30">Greece (+30)</li>
	<li data-countryCode="GL" value="+299">Greenland (+299)</li>
	<li data-countryCode="GD" value="+1473">Grenada (+1473)</li>
	<li data-countryCode="GP" value="+590">Guadeloupe (+590)</li>
	<li data-countryCode="GU" value="+671">Guam (+671)</li>
	<li data-countryCode="GT" value="+502">Guatemala (+502)</li>
	<li data-countryCode="GN" value="+224">Guinea (+224)</li>
	<li data-countryCode="GW" value="+245">Guinea - Bissau (+245)</li>
	<li data-countryCode="GY" value="+592">Guyana (+592)</li>
	<li data-countryCode="HT" value="+509">Haiti (+509)</li>
	<li data-countryCode="HN" value="+504">Honduras (+504)</li>
	<li data-countryCode="HK" value="+852">Hong Kong (+852)</li>
	<li data-countryCode="HU" value="+36">Hungary (+36)</li>
	<li data-countryCode="IS" value="+354">Iceland (+354)</li>
	<li data-countryCode="IN" value="+91">India (+91)</li>
	<li data-countryCode="ID" value="+62">Indonesia (+62)</li>
	<li data-countryCode="IR" value="+98">Iran (+98)</li>
	<li data-countryCode="IQ" value="+964">Iraq (+964)</li>
	<li data-countryCode="IE" value="+353">Ireland (+353)</li>
	<li data-countryCode="IL" value="+972">Israel (+972)</li>
	<li data-countryCode="IT" value="+39">Italy (+39)</li>
	<li data-countryCode="JM" value="+1876">Jamaica (+1876)</li>
	<li data-countryCode="JP" value="+81">Japan (+81)</li>
	<li data-countryCode="JO" value="+962">Jordan (+962)</li>
	<li data-countryCode="KZ" value="+7">Kazakhstan (+7)</li>
	<li data-countryCode="KE" value="+254">Kenya (+254)</li>
	<li data-countryCode="KI" value="+686">Kiribati (+686)</li>
	<li data-countryCode="KP" value="+850">Korea North (+850)</li>
	<li data-countryCode="KR" value="+82">Korea South (+82)</li>
	<li data-countryCode="KW" value="+965">Kuwait (+965)</li>
	<li data-countryCode="KG" value="+996">Kyrgyzstan (+996)</li>
	<li data-countryCode="LA" value="+856">Laos (+856)</li>
	<li data-countryCode="LV" value="+371">Latvia (+371)</li>
	<li data-countryCode="LB" value="+961">Lebanon (+961)</li>
	<li data-countryCode="LS" value="+266">Lesotho (+266)</li>
	<li data-countryCode="LR" value="+231">Liberia (+231)</li>
	<li data-countryCode="LY" value="+218">Libya (+218)</li>
	<li data-countryCode="LI" value="+417">Liechtenstein (+417)</li>
	<li data-countryCode="LT" value="+370">Lithuania (+370)</li>
	<li data-countryCode="LU" value="+352">Luxembourg (+352)</li>
	<li data-countryCode="MO" value="+853">Macao (+853)</li>
	<li data-countryCode="MK" value="+389">Macedonia (+389)</li>
	<li data-countryCode="MG" value="+261">Madagascar (+261)</li>
	<li data-countryCode="MW" value="+265">Malawi (+265)</li>
	<li data-countryCode="MY" value="+60">Malaysia (+60)</li>
	<li data-countryCode="MV" value="+960">Maldives (+960)</li>
	<li data-countryCode="ML" value="+223">Mali (+223)</li>
	<li data-countryCode="MT" value="+356">Malta (+356)</li>
	<li data-countryCode="MH" value="+692">Marshall Islands (+692)</li>
	<li data-countryCode="MQ" value="+596">Martinique (+596)</li>
	<li data-countryCode="MR" value="+222">Mauritania (+222)</li>
	<li data-countryCode="YT" value="+269">Mayotte (+269)</li>
	<li data-countryCode="MX" value="+52">Mexico (+52)</li>
	<li data-countryCode="FM" value="+691">Micronesia (+691)</li>
	<li data-countryCode="MD" value="+373">Moldova (+373)</li>
	<li data-countryCode="MC" value="+377">Monaco (+377)</li>
	<li data-countryCode="MN" value="+976">Mongolia (+976)</li>
	<li data-countryCode="MS" value="+1664">Montserrat (+1664)</li>
	<li data-countryCode="MA" value="+212">Morocco (+212)</li>
	<li data-countryCode="MZ" value="+258">Mozambique (+258)</li>
	<li data-countryCode="MN" value="+95">Myanmar (+95)</li>
	<li data-countryCode="NA" value="+264">Namibia (+264)</li>
	<li data-countryCode="NR" value="+674">Nauru (+674)</li>
	<li data-countryCode="NP" value="+977">Nepal (+977)</li>
	<li data-countryCode="NL" value="+31">Netherlands (+31)</li>
	<li data-countryCode="NC" value="+687">New Caledonia (+687)</li>
	<li data-countryCode="NZ" value="+64">New Zealand (+64)</li>
	<li data-countryCode="NI" value="+505">Nicaragua (+505)</li>
	<li data-countryCode="NE" value="+227">Niger (+227)</li>
	<li data-countryCode="NG" value="+234">Nigeria (+234)</li>
	<li data-countryCode="NU" value="+683">Niue (+683)</li>
	<li data-countryCode="NF" value="+672">Norfolk Islands (+672)</li>
	<li data-countryCode="NP" value="+670">Northern Marianas (+670)</li>
	<li data-countryCode="NO" value="+47">Norway (+47)</li>
	<li data-countryCode="OM" value="+968">Oman (+968)</li>
	<li data-countryCode="PW" value="+680">Palau (+680)</li>
	<li data-countryCode="PA" value="+507">Panama (+507)</li>
	<li data-countryCode="PG" value="+675">Papua New Guinea (+675)</li>
	<li data-countryCode="PY" value="+595">Paraguay (+595)</li>
	<li data-countryCode="PE" value="+51">Peru (+51)</li>
	<li data-countryCode="PH" value="+63">Philippines (+63)</li>
	<li data-countryCode="PL" value="+48">Poland (+48)</li>
	<li data-countryCode="PT" value="+351">Portugal (+351)</li>
	<li data-countryCode="PR" value="+1787">Puerto Rico (+1787)</li>
	<li data-countryCode="QA" value="+974">Qatar (+974)</li>
	<li data-countryCode="RE" value="+262">Reunion (+262)</li>
	<li data-countryCode="RO" value="+40">Romania (+40)</li>
	<li data-countryCode="RU" value="+7">Russia (+7)</li>
	<li data-countryCode="RW" value="+250">Rwanda (+250)</li>
	<li data-countryCode="SM" value="+378">San Marino (+378)</li>
	<li data-countryCode="ST" value="+239">Sao Tome & Principe (+239)</li>
	<li data-countryCode="SA" value="+966">Saudi Arabia (+966)</li>
	<li data-countryCode="SN" value="+221">Senegal (+221)</li>
	<li data-countryCode="CS" value="+381">Serbia (+381)</li>
	<li data-countryCode="SC" value="+248">Seychelles (+248)</li>
	<li data-countryCode="SL" value="+232">Sierra Leone (+232)</li>
	<li data-countryCode="SG" value="+65">Singapore (+65)</li>
	<li data-countryCode="SK" value="+421">Slovak Republic (+421)</li>
	<li data-countryCode="SI" value="+386">Slovenia (+386)</li>
	<li data-countryCode="SB" value="+677">Solomon Islands (+677)</li>
	<li data-countryCode="SO" value="+252">Somalia (+252)</li>
	<li data-countryCode="ZA" value="+27">South Africa (+27)</li>
	<li data-countryCode="ES" value="+34">Spain (+34)</li>
	<li data-countryCode="LK" value="+94">Sri Lanka (+94)</li>
	<li data-countryCode="SH" value="+290">St. Helena (+290)</li>
	<li data-countryCode="KN" value="+1869">St. Kitts (+1869)</li>
	<li data-countryCode="SC" value="+1758">St. Lucia (+1758)</li>
	<li data-countryCode="SD" value="+249">Sudan (+249)</li>
	<li data-countryCode="SR" value="+597">Suriname (+597)</li>
	<li data-countryCode="SZ" value="+268">Swaziland (+268)</li>
	<li data-countryCode="SE" value="+46">Sweden (+46)</li>
	<li data-countryCode="CH" value="+41">Switzerland (+41)</li>
	<li data-countryCode="SI" value="+963">Syria (+963)</li>
	<li data-countryCode="TW" value="+886">Taiwan (+886)</li>
	<li data-countryCode="TJ" value="+7">Tajikstan (+7)</li>
	<li data-countryCode="TH" value="+66">Thailand (+66)</li>
	<li data-countryCode="TG" value="+228">Togo (+228)</li>
	<li data-countryCode="TO" value="+676">Tonga (+676)</li>
	<li data-countryCode="TT" value="+1868">Trinidad & Tobago (+1868)</li>
	<li data-countryCode="TN" value="+216">Tunisia (+216)</li>
	<li data-countryCode="TR" value="+90">Turkey (+90)</li>
	<li data-countryCode="TM" value="+7">Turkmenistan (+7)</li>
	<li data-countryCode="TM" value="+993">Turkmenistan (+993)</li>
	<li data-countryCode="TC" value="+1649">Turks & Caicos Islands (+1649)</li>
	<li data-countryCode="TV" value="+688">Tuvalu (+688)</li>
	<li data-countryCode="UG" value="+256">Uganda (+256)</li>
	<li data-countryCode="UA" value="+380">Ukraine (+380)</li>
	<li data-countryCode="AE" value="+971">United Arab Emirates (+971)</li>
	<li data-countryCode="UY" value="+598">Uruguay (+598)</li>
	<li data-countryCode="UZ" value="+7">Uzbekistan (+7)</li>
	<li data-countryCode="VU" value="+678">Vanuatu (+678)</li>
	<li data-countryCode="VA" value="+379">Vatican City (+379)</li>
	<li data-countryCode="VE" value="+58">Venezuela (+58)</li>
	<li data-countryCode="VN" value="+84">Vietnam (+84)</li>
	<li data-countryCode="VG" value="+84">Virgin Islands - British (+1284)</li>
	<li data-countryCode="VI" value="+84">Virgin Islands - US (+1340)</li>
	<li data-countryCode="WF" value="+681">Wallis & Futuna (+681)</li>
	<li data-countryCode="YE" value="+969">Yemen (North)(+969)</li>
	<li data-countryCode="YE" value="+967">Yemen (South)(+967)</li>
	<li data-countryCode="ZM" value="+260">Zambia (+260)</li>
	<li data-countryCode="ZW" value="+263">Zimbabwe (+263)</li>
</ul>
</template>

<script>
 export default {
     name: 'Country-list',
     components: {

     },
     data() {
         return {
             sel_country: ''
         }
     },
     watch: {
         async errors(n) {

         }
     },
     computed: {},

     mounted() {},

     methods: {
         onClickButton(click) {
             if (click.target.tagName == "LI") {
                 let value = click.target.value.toString()
                 if (click.target.attributes.value.value) {
                     value = click.target.attributes.value.value
                 }
                 this.$emit('clicked', value)
                 this.$emit('input', value);
             }
         }
     }
 };

</script>
